// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#card-element {\n  -o-object-fit: contain;\n     object-fit: contain;\n  border-radius: 1.5rem;\n  box-shadow: 0 3px 20px 0 rgba(17, 17, 95, 0.1);\n  background-color: #ffffff;\n  padding: 1rem;\n}\n.text-red {\n  color: #db003e;\n}\n.notices .toast-error {\n  background: #000;\n}\n.notices .toast {\n  opacity: 1;\n}", ""]);
// Exports
module.exports = exports;
